import Polyglot from "node-polyglot";
import { CookieControlService } from "./CookieControlService";
import { CookiePurpose } from "./CookiePurpose";
export class DefaultCookieControlManager {
    constructor(polyglotPhrases, necessaryCookies, optionalCookies, socialCookies, preferenceCookies) {
        this.polyglotPhrases = polyglotPhrases;
        this.necessaryCookies = necessaryCookies;
        this.optionalCookies = optionalCookies;
        this.socialCookies = socialCookies;
        this.preferenceCookies = preferenceCookies;
        this.translator = new Polyglot({ phrases: polyglotPhrases });
    }
    Init(onAcceptOptionalCookies, onRejectOptionalCookies, onAcceptSocialCookies, onRejectSocialCookies, onAcceptPreferenceCookies, onRejectPreferenceCookies) {
        const config = this.GetCookieControlConfiguration();
        this.cookieControlService = new CookieControlService();
        this.cookieControlService.Init(config);
        this.acceptOptionalCookiesCallBack = onAcceptOptionalCookies;
        this.rejectOptionalCookiesCallBack = onRejectOptionalCookies;
        this.acceptSocialCookiesCallBack = onAcceptSocialCookies;
        this.rejectSocialCookiesCallBack = onRejectSocialCookies;
        this.acceptPreferenceCookiesCallBack = onAcceptPreferenceCookies;
        this.rejectPreferenceCookiesCallBack = onRejectPreferenceCookies;
        $("#cookie-settings").on("click", () => {
            this.cookieControlService.Open();
        });
    }
    GetCookieControlConfiguration() {
        const self = this;
        return {
            apiKey: $("#cookieControlApiKey").val(),
            product: 'PRO_MULTISITE',
            necessaryCookies: this.necessaryCookies || [],
            statement: {
                description: this.translator.t("statement_description"),
                name: this.translator.t("statement_name"),
                url: this.translator.t("statement_url"),
                updated: this.translator.t("statement_date")
            },
            rejectButton: false,
            closeStyle: "button",
            text: {
                notifyDescription: this.translator.t("notify_description"),
                notifyTitle: this.translator.t("notify_title"),
                thirdPartyTitle: this.translator.t("third_party_cookies_title"),
                thirdPartyDescription: this.translator.t("third_party_cookies_description"),
                closeLabel: this.translator.t("close_label"),
                accept: this.translator.t("notification_bar_accept"),
                intro: this.translator.t("panel_intro"),
                title: this.translator.t("panel_title"),
                acceptSettings: this.translator.t("panel_accept_all"),
            },
            branding: {
                fontFamily: "Noto Sans, sans-serif",
                fontColor: "#fcfcfc",
                fontSizeTitle: "1.0625rem",
                fontSizeIntro: ".9375rem",
                fontSizeHeaders: "1rem",
                fontSize: ".75rem",
                backgroundColor: "#333",
                toggleText: "#fcfcfc",
                toggleColor: "#fcfcfc",
                toggleBackground: "#333",
                acceptBackground: "#c60c30",
                acceptText: "#fcfcfc",
                rejectBackground: "#c60c30",
                rejectText: "#fcfcfc",
                buttonIcon: "",
                buttonIconWidth: 120,
                buttonIconHeight: 120,
                removeIcon: true,
                removeAbout: true
            },
            optionalCookieList: [
                {
                    name: CookiePurpose.Analytics,
                    label: this.translator.t("analytics_label"),
                    description: this.translator.t("analytics_description"),
                    cookies: this.optionalCookies || [],
                    vendors: [{
                            name: this.translator.t("google_name"),
                            url: this.translator.t("google_url"),
                            description: this.translator.t("google_description")
                        },
                        {
                            name: this.translator.t("piwik_name"),
                            url: this.translator.t("piwik_url"),
                            description: this.translator.t("piwik_description")
                        },
                        {
                            name: this.translator.t("mather_name"),
                            url: this.translator.t("mather_url"),
                            description: this.translator.t("mather_description")
                        }
                    ],
                    onAcceptCallback: function () {
                        if (self.acceptOptionalCookiesCallBack) {
                            self.acceptOptionalCookiesCallBack();
                        }
                    },
                    onRevokeCallback: function () {
                        if (self.rejectOptionalCookiesCallBack) {
                            self.rejectOptionalCookiesCallBack();
                        }
                    }
                },
                {
                    name: CookiePurpose.Social,
                    label: this.translator.t("social_name"),
                    description: this.translator.t("social_description"),
                    cookies: this.socialCookies || [],
                    onAcceptCallback: function () {
                        if (self.acceptSocialCookiesCallBack) {
                            self.acceptSocialCookiesCallBack();
                        }
                    },
                    onRevokeCallback: function () {
                        if (self.rejectSocialCookiesCallBack) {
                            self.rejectSocialCookiesCallBack();
                        }
                    }
                },
                {
                    name: CookiePurpose.Preferences,
                    label: this.translator.t("preferences_name"),
                    description: this.translator.t("preferences_description"),
                    cookies: this.preferenceCookies || [],
                    onAcceptCallback: function () {
                        if (self.acceptPreferenceCookiesCallBack) {
                            self.acceptPreferenceCookiesCallBack();
                        }
                    },
                    onRevokeCallback: function () {
                        if (self.rejectPreferenceCookiesCallBack) {
                            self.rejectPreferenceCookiesCallBack();
                        }
                    }
                }
            ]
        };
    }
    UpdateConsent(purpose, consent) {
        this.cookieControlService.UpdateConsent(purpose, consent);
    }
}
//# sourceMappingURL=DefaultCookieControlManager.js.map